import {
  AuthenticationResult,
  PublicClientApplication,
} from '@azure/msal-browser';
import _ from 'lodash';
import { IApiServiceGeneric } from '@dirootie-http/api-types';
import { AuthorizationService } from './authorization.service';
import { UserProfile } from './user-profile';
import { SessionStore } from './session.store';

export class AuthenticationService {
  public static inject = [
    'apiService',
    'msalInstance',
    'authorizationService',
  ] as const;
  constructor(
    private apiService: IApiServiceGeneric,
    private msalInstance: PublicClientApplication,
    private authorizationService: AuthorizationService,
    private sessionStore: SessionStore,
  ) {
    // this.apiService =
    //   serviceFactory.createApiServiceFromPath('users.registered');
    this.initialize();
  }

  initialize(): void {
    // const accounts = this.msalInstance.getAllAccounts();
    // if(accounts.length > 0) {
    //   this.sessionStore.setProfileFromToken(accounts[0] as any);
    //   console.log("USER_PROFILE", this.sessionStore.userProfile);
    // }
    // console.log("USER_ACCUNTS", accounts);
  }

  isAuthenticated(): boolean {
    const isLoggedIn = this.msalInstance.getAllAccounts().length > 0;
    return isLoggedIn;
  }

  getAccountInfo(from?: string) {
    return this.apiService
      .getUrl<UserProfile>('usersms/users/self/verification')
      .then((x: any) => {
        return this.handleAccount(x, from);
      })
      .catch((e) => {
        return this.handleAccountError(e);
      });
  }

  loginSuccess(result: AuthenticationResult): Promise<void> {
    return this.getAccountInfo();
  }

  handleAccount(profile: UserProfile, from?: string): Promise<void> {
    if (profile !== undefined && profile.accountState !== undefined) {
      if (
        profile.accountState === 'REGISTERED' ||
        profile.accountState === 'ACTIVE'
      ) {
        this.authorizationService.handleActiveAccount(profile, from);
        return Promise.resolve();
      }
      if (profile.accountState === 'INVITED') {
        this.authorizationService.handleInvitedAccount(profile, from);
        return Promise.resolve();
      }

      if (
        profile.accountState === 'BLOCKED' ||
        profile.accountState === 'SUSPENDED'
      ) {
        this.authorizationService.handleBlockedAccount(profile);
        return Promise.resolve();
      }
    }
    return Promise.resolve();
  }

  handleAccountError(x: any): Promise<void> {
    // const profile: UserProfile = {
    //   accountState: 'ACTIVE',
    //   displayName: 'XC',
    //   email: 'd@f,c',
    //   role: 'STUDY_DIRECTOR',
    //   id: '123',
    // } as any;

    // this.authorizationService.handleActiveAccount(profile);
    // return Promise.resolve();
    if (
      _.isUndefined(x) ||
      _.isUndefined(x.response) ||
      _.isUndefined(x.response.status)
    ) {
      this.authorizationService.handleAccountError();
      return Promise.reject();
    }
    const { response } = x;
    if (
      response.status === 422 &&
      x.response.data.detail === 'Account does not exist!'
    ) {
      this.authorizationService.handleNonExistingAccount(x);
      return Promise.reject();
    }
    if (
      (response.status === 422 &&
        x.response.data.detail === 'Account is blocked!') ||
      response.data.detail === 'Account is suspended!'
    ) {
      this.authorizationService.handleBlockedAccount(x);
      return Promise.reject();
    }
    return Promise.reject();
  }

  loginUnsuccess(result: AuthenticationResult): Promise<void> {
    return Promise.resolve();
  }

  logout(): Promise<void> {
    return Promise.resolve();
  }
}
